import { useQuery, useQueryClient } from "@tanstack/react-query";

import { getFootprintingPigletFeedProduction, getFootprintingPigletFeedProductionAdmin } from "services";

import { getEnvironment } from "utils";

import { FOOTPRINTING_PIGLET_FEED_PRODUCTION } from "consts";

export const useGetFootprintingPigletFeedProduction = (feedInformationId?: string) => {
  const isAdmin = getEnvironment().admin;
  const queryClient = useQueryClient();
  return useQuery(
    {
      queryKey: [FOOTPRINTING_PIGLET_FEED_PRODUCTION, feedInformationId, isAdmin],
      queryFn: () =>
        isAdmin ? getFootprintingPigletFeedProductionAdmin(feedInformationId ?? "") : getFootprintingPigletFeedProduction(feedInformationId ?? ""),
      enabled: !!feedInformationId,
      staleTime: 0,
      gcTime: 0,
    },
    queryClient
  );
};
